export enum UI_STATE {
  OPT_IN,
  SUBSCRIBED,
  UNSUBSCRIBED,
  ERROR_API,
  ERROR_VALIDATION,
  CPREF_CONFIRM,
  CPREF_SUBSCRIBED,
  CPREF_UNSUBSCRIBED,
  CPREF_MARKETING,
}

export enum Channels {
  SMS = 'sms',
  EMAIL = 'email',
  HIPAA_SMS = 'hipaa_sms',
  HIPAA_EMAIL = 'hipaa_email',
  APP_PUSH = 'app_push',
  LINE = 'line',
  SUBLIME = 'sublime',
}

export enum PreferenceLevels {
  TRACKING = 'TRACKING',
  ORDER = 'ORDER',
  RETAILER = 'RETAILER',
  ORDER_ONLY = 'ORDER_ONLY',
}
